import { isGradePassed, trim, yearsFromNow, daysFromYearsAgo, filterZeroArrays, getCoursesFromColleges, empty, totalCourseCredits, getTotalLoggedHours, handleize, coursesWithCreditsTotal } from '@/lib/utils'

const HEALTH_CARE_MAPPING = {
  healthcare_experience_direct_paid_patient_hours: 'direct_paid_patient_experience',
  healthcare_experience_direct_patient_hours: 'direct_patient_experience',
  healthcare_experience_indirect_patient_hours: 'indirect_patient_experience',
  healthcare_experience_volunteer_hours: 'volunteer_experience'
}

export default {
  methods: {
    hasCertification (requiredCert) {
      return this.certificationsInfo.find(cert => {
        return cert.certification_type === requiredCert
      })
    },

    hasValidHealthCareHours (kind) {
      let minExperienceYears = this.minHealthCareExpYears
      if (empty(this.savedSchool[kind])) return true
      const hours = getTotalLoggedHours(this.user[HEALTH_CARE_MAPPING[kind]], minExperienceYears)
      return hours
    }
  },
  computed: {

     // Checks if user has completed all required healthcare experience
     completedAllHealthcareExp () {
      if(this.hasHealthCareExperience &&
        this.hasCommunityServiceHours &&
        this.hasCompletedCertifications)
        return true
    },
    hasCommunityServiceHours() {
      if(this.minCommunityServiceHours === 0 ) return true
      if(this.minCommunityServiceHours === 0 && this.totalCommunityServiceHours === this.minCommunityServiceHours) return false
      if(this.totalCommunityServiceHours >= this.minCommunityServiceHours) return true
    },
     // Community Service Hours
     minCommunityServiceHours () {
      if (empty(this.savedSchool.healthcare_experience_community_service_hours)) return 0
      return Number(this.savedSchool.healthcare_experience_community_service_hours.split(',').join(''))
    },
    // Healthcare Experience Hours
    calculatePendingHealthcareHours () {
      return this.minHealthCareHours - this.totalAcceptedHealthCareHours
    },
    minHealthCareHours () {
      if (empty(this.savedSchool.healthcare_experience_minimum_hours)) return 0
      return Number(this.savedSchool.healthcare_experience_minimum_hours.split(',').join(''))
    },
    minHealthCareExpYears () {
      let minExperienceYears = Number(this.savedSchool.healthcare_experience_minimum_year)
      if (isNaN(minExperienceYears)) {
        minExperienceYears = 0
      }
      return minExperienceYears
    },
    hasHealthCareExperience () {
      if (this.savedSchool.healthcare_experience_recommended === true) return this.totalAcceptedHealthCareHours >= 0
      if (this.savedSchool.healthcare_experience_required === true) {
        if (!empty(this.savedSchool.healthcare_experience_volunteer_hours) && this.savedSchool.healthcare_experience_volunteer_hours) {
          const volHours = getTotalLoggedHours(this.user.volunteer_experience, this.minHealthCareExpYears)
          if (volHours < parseInt(this.savedSchool.healthcare_experience_minimum_volunteer_hours)) return false
        }
        if (empty(this.savedSchool.healthcare_experience_minimum_hours)) return this.totalAcceptedHealthCareHours > 0
        return this.totalAcceptedHealthCareHours >= this.minHealthCareHours
      }
      return false
    },
    totalAcceptedHealthCareHours () {
      let totalHours = 0
      let minExperienceYears = this.minHealthCareExpYears
      if (
        empty(this.savedSchool.healthcare_experience_direct_paid_patient_hours) &&
        empty(this.savedSchool.healthcare_experience_direct_patient_hours) &&
        empty(this.savedSchool.healthcare_experience_indirect_patient_hours) &&
        empty(this.savedSchool.healthcare_experience_volunteer_hours)
      ) {
        return (
          getTotalLoggedHours(this.user.direct_paid_patient_experience, minExperienceYears) +
          getTotalLoggedHours(this.user.direct_patient_experience, minExperienceYears) +
          getTotalLoggedHours(this.user.indirect_patient_experience, minExperienceYears) +
          getTotalLoggedHours(this.user.volunteer_experience, minExperienceYears)
        )
      }
      if (this.savedSchool.healthcare_experience_direct_paid_patient_hours && this.user.direct_paid_patient_experience) {
        totalHours += getTotalLoggedHours(this.user.direct_paid_patient_experience, minExperienceYears)
      }
      if (this.savedSchool.healthcare_experience_direct_patient_hours && this.user.direct_patient_experience) {
        totalHours += getTotalLoggedHours(this.user.direct_patient_experience, minExperienceYears)
      }
      if (this.savedSchool.healthcare_experience_indirect_patient_hours && this.user.indirect_patient_experience) {
        totalHours += getTotalLoggedHours(this.user.indirect_patient_experience, minExperienceYears)
      }
      if (this.savedSchool.healthcare_experience_volunteer_hours && this.user.volunteer_experience) {
        totalHours += getTotalLoggedHours(this.user.volunteer_experience, minExperienceYears)
      }
      return totalHours
      // var totalUserHours = this.totalDirectPaidHours + this.totalDirectHours + this.totalIndirectHours +  this.totalVolunteerHours
    },
    hasCompletedCertifications () {
      return this.totalRequiredCertifications.every((cert) => {
        return this.completedCertifications.includes(cert)
      })
    },
    completedCertifications () {
      let finalArray = [];
      let usercompletedCert = [];
      let reqCert =  this.totalRequiredCertifications
      this.certificationsInfo.forEach(cert => {
        usercompletedCert.push(cert.certification_type)
      })

      reqCert.forEach((e1) => usercompletedCert.forEach((e2) => {
        if(e1 === e2) {
          finalArray.push(e1)
        }
      }))

      return finalArray
    },

    totalRequiredCertifications() {
      let requiredCertifications = [];
      if(this.savedSchool.cpr) {
        requiredCertifications.push('CPR')
      }
      if(this.savedSchool.basic_life_support) {
        requiredCertifications.push('BLS')
      }
       if(this.savedSchool.acls) {
        requiredCertifications.push('ACLS')
      }

      return requiredCertifications
    },
    totalUserHealthcareHours () {
      let totalUserHours = 0
      if(this.savedSchool.healthcare_experience_direct_paid_patient_hours === true) {
        totalUserHours += this.totalDirectPaidHours
      }

      if(this.savedSchool.healthcare_experience_direct_patient_hours === true) {
        totalUserHours += this.totalDirectHours
      }

      if(this.savedSchool.healthcare_experience_indirect_patient_hours === true) {
        totalUserHours += this.totalIndirectHours
      }

      if(this.savedSchool.healthcare_experience_volunteer_hours === true) {
        totalUserHours += this.totalVolunteerHours
      }
      return totalUserHours
    },

  }
}



// WEBPACK FOOTER //
// ./src/mixins/requirementchecks/checkhealthcareexperiencemixin.js